// İSG uzmanı portalı — Çalışma İzni Tipleri kabuğu (owner review B2 item 7, 2026-09-28) —
// Admin/Ayarlar/Ziyaretçiler kabuklarıyla AYNI desen (`AdminShell.tsx`/`SettingsShell.tsx`'in
// dosya başlığı notu). Eskiden dört kardeş sayfanın (Tipler/KKD/Kontrol Maddeleri/Onay
// Yönlendirme) HER BİRİ kendi Breadcrumb+PageHeader'ını taşıyordu — sekme değişince BAŞLIK
// (`<h1>`) da o sekmenin adına ("KKD Kataloğu" gibi) DÖNÜŞÜYOR, sayfa her tıklamada ZIPLIYORDU
// (owner review B2 item 7). Tek gerçek başlık artık kabukta ("Çalışma İzni Tipleri", HİÇBİR
// sekmede değişmez); sekme adı yalnız sekme çubuğunda. PageHeader'ın sağındaki birincil aksiyon
// (Yeni Tip/KKD/Kontrol Maddesi/Routing) o an AKTİF sekmenin kendisidir (`ShellHeaderAction`
// portal köprüsü — bkz. o dosyanın başlığı). Dört sayfa da artık kendi yerel Breadcrumb/
// PageHeader'ını TAŞIMAZ (kabuğun `<h1>`'i TEK gerçek başlık) — eski `PermitCatalogTabs.tsx`
// (dört sayfanın kendi kopyaladığı sekme dizisi) bu kabuğa taşınarak SİLİNDİ, `RouteTabs`'ın
// diğer üç kabukla ortak deseni (dosya başlığında ADI GEÇEN dördüncü tüketici, artık DOLAYSIZ).

import { Breadcrumb, PageHeader } from '@isgportal/shared';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { RouteTabs } from '../../components/layout/RouteTabs';
import {
  ShellHeaderActionProvider,
  useShellHeaderActionSlot,
} from '../../components/layout/ShellHeaderAction';

export function PermitTypesShell() {
  const { t } = useTranslation();
  const { slotRef, slot } = useShellHeaderActionSlot();

  return (
    <div className="flex flex-col gap-6">
      <Breadcrumb items={[{ label: t('permitTypes.title') }]} />
      <PageHeader
        title={t('permitTypes.title')}
        helperText={t('permitTypes.subtitle')}
        actions={slot}
      />
      {/* Sekme listesi + gövde ARASINDA boşluk YOK (S33 Slice 6 owner kararı, bkz.
          `SettingsShell.tsx`'in aynı notu). */}
      <div className="flex flex-col">
        <RouteTabs
          ariaLabel={t('permitTypes.catalog.tabs.label')}
          items={[
            { to: '/permit-types', end: true, label: t('permitTypes.catalog.tabs.types') },
            {
              to: '/permit-types/protective-equipment',
              label: t('permitTypes.catalog.tabs.ppe'),
            },
            {
              to: '/permit-types/control-items',
              label: t('permitTypes.catalog.tabs.controls'),
            },
            {
              to: '/permit-types/approval-routing',
              label: t('permitTypes.catalog.tabs.approvalRouting'),
            },
          ]}
        />
        <ShellHeaderActionProvider value={slotRef}>
          <Outlet />
        </ShellHeaderActionProvider>
      </div>
    </div>
  );
}
